import { AppIcon, type IconName } from '../../../components/icons/AppIcon';
import { cnFilterChip } from '../../../components/shared/filters/filterChipStyles';
import type { TaskChip } from '../lib/taskBuckets';

type ChipCounts = Partial<Record<TaskChip, number>>;

interface TaskFilterChipsProps {
  active: TaskChip;
  onChange: (chip: TaskChip) => void;
  counts: ChipCounts;
}

const CHIPS: { id: TaskChip; label: string; icon?: IconName }[] = [
  { id: 'all', label: 'Todas' },
  { id: 'mine', label: 'Meus', icon: 'user' },
];

export function TaskFilterChips({ active, onChange, counts }: TaskFilterChipsProps) {
  return (
    <nav
      className="flex shrink-0 gap-s2"
      aria-label="Filtros de tarefas"
    >
      {CHIPS.map(chip => {
        const isActive = active === chip.id;
        const count = counts[chip.id];
        return (
          <button
            key={chip.id}
            type="button"
            onClick={() => onChange(isActive ? 'all' : chip.id)}
            className={cnFilterChip(isActive, 'pill')}
            aria-pressed={isActive}
          >
            {chip.icon && <AppIcon name={chip.icon} className="size-3 shrink-0" aria-hidden />}
            {chip.label}
            {chip.id === 'mine' && typeof count === 'number' && (
              <span className="inline-flex min-h-5 min-w-5 items-center justify-center rounded-full bg-surface-subtle px-s2 font-mono text-2xs font-medium leading-none tabular-nums text-default">
                {count}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
